module.exports = __webpack_public_path__ + "img/杭州硕联LOGO.9b3c6e8b.png";